import React from 'react';
import { Link } from 'react-router-dom';
import { FiPackage, FiX, FiClock, FiInbox } from 'react-icons/fi';
import TarjetaPerfil, { Skeleton, Vacio } from './TarjetaPerfil';

/**
 * Servicios contratados. Cuando el admin puede editarlos, refleja la selección
 * pendiente (no la guardada) para que cuadre con la barra de guardado, y deja
 * quitarlos desde el propio chip.
 */
const TarjetaServicios = ({ servicios, cargando, editable, onQuitar, hayPendientes }) => {
  const totalHoras = servicios.reduce((acc, s) => acc + (s.horas || 0), 0);

  return (
    <TarjetaPerfil
      icono={FiPackage}
      titulo="Servicios contratados"
      extra={!cargando && totalHoras > 0 && (
        <span className="perfil-card-contador perfil-card-contador--horas">
          <FiClock /> {totalHoras} h
        </span>
      )}
    >
      {cargando ? (
        <Skeleton filas={2} />
      ) : servicios.length === 0 ? (
        <Vacio
          icono={FiInbox}
          accion={editable && (
            <Link className="perfil-card-ver-mas" to="/dashboard/gestion-servicios">
              Ir al catálogo de servicios
            </Link>
          )}
        >
          Sin servicios asignados.
        </Vacio>
      ) : (
        <>
          <div className="perfil-servicios-chips">
            {servicios.map((servicio) => (
              <span key={servicio.id} className={`perfil-servicio-chip perfil-servicio-chip--${servicio.categoria}`}>
                <span className="perfil-servicio-chip-titulo">{servicio.titulo}</span>
                {servicio.horas ? <span className="perfil-servicio-chip-horas">{servicio.horas} h</span> : null}
                {editable && (
                  <button
                    type="button"
                    onClick={() => onQuitar(servicio.id)}
                    title={`Quitar ${servicio.titulo}`}
                    aria-label={`Quitar ${servicio.titulo}`}
                  >
                    <FiX />
                  </button>
                )}
              </span>
            ))}
          </div>

          {hayPendientes && (
            <p className="perfil-card-aviso">Cambios sin guardar en los servicios.</p>
          )}
        </>
      )}
    </TarjetaPerfil>
  );
};

export default TarjetaServicios;
